import React, { useState } from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
interface QuizOption {
  text: string;
  isCorrect: boolean;
  feedback?: string;
}
interface QuizProps {
  question: string;
  options: QuizOption[];
  onAnswer?: (isCorrect: boolean) => void;
}
export function Quiz({
  question,
  options,
  onAnswer
}: QuizProps) {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [showFeedback, setShowFeedback] = useState(false);
  const handleOptionClick = (index: number) => {
    if (selectedIndex !== null) return; // Already answered
    setSelectedIndex(index);
    setShowFeedback(true);
    onAnswer?.(options[index].isCorrect);
  };
  const selectedOption = selectedIndex !== null ? options[selectedIndex] : null;
  return <div className="px-6 py-8" data-id="element-123">
      <h3 className="text-lg font-semibold text-text-primary mb-6 leading-snug" data-id="element-124">
        {question}
      </h3>

      <div className="space-y-3" data-id="element-125">
        {options.map((option, index) => {
        const isSelected = selectedIndex === index;
        const isAnswered = selectedIndex !== null;
        return <button key={index} onClick={() => handleOptionClick(index)} disabled={isAnswered} className={`w-full text-left px-5 py-4 rounded-lg border-2 transition-smooth ${isSelected ? option.isCorrect ? 'border-correct-green bg-green-50' : 'border-incorrect-orange bg-orange-50' : isAnswered ? 'border-gray-200 bg-gray-50 opacity-50' : 'border-border-gray bg-white active:bg-gray-50'}`} aria-pressed={isSelected} data-id="element-126">
              <span className="font-medium text-text-primary" data-id="element-127">
                {option.text}
              </span>
            </button>;
      })}
      </div>

      {/* Feedback overlay */}
      {showFeedback && selectedOption && <div className={`mt-4 p-4 rounded-lg feedback-overlay ${selectedOption.isCorrect ? 'bg-correct-green text-white' : 'bg-incorrect-orange text-white'}`} role="alert" data-id="element-128">
          <div className="flex items-start gap-3" data-id="element-129">
            {selectedOption.isCorrect ? <CheckCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-130" /> : <XCircleIcon className="w-6 h-6 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-131" />}
            <div data-id="element-132">
              <p className="font-semibold mb-1" data-id="element-133">
                {selectedOption.isCorrect ? 'Correct!' : 'Not quite'}
              </p>
              {selectedOption.feedback && <p className="text-sm opacity-95" data-id="element-134">{selectedOption.feedback}</p>}
            </div>
          </div>
        </div>}
    </div>;
}